import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid, Section } from '@gogame/components';

import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import Filters from './filters';

const AllFilters = ({ open, onClose, onExited }) => {
  const {
    isAllowRequestedBy,
    isAllowDesigner,
    isAllowOutsourceStudio,
    isAllowPerformance,
    isAllowConceptFamilies,
    isAllowBusinessPartner,
    isAllowSharedWith,
    isAllowStatuses,
    isAllowPromoCodes,
    isAllowExclusiveForAffiliates,
    isAllowTested,
    isAllowProductionType,
  } = useGalleryPermissions();
  return (
    <AllFiltersProvider open={open} onClose={onClose} onExited={onExited}>
      <Section title={'Date'} paddingTop={0}>
        <Grid container={true} spacing={2}>
          <Grid item xs={4}>
            <Filters.ConceptsAdded />
          </Grid>
          <Grid item xs={4}>
            <Filters.CreativesAdded />
          </Grid>
          <Grid item xs={4}>
            <Filters.ExpirationPeriod withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.StartPeriod withFavoriteActions={true} />
          </Grid>
        </Grid>
      </Section>
      <Section title={'Targeting'}>
        <Grid container={true} spacing={2}>
          <Grid item xs={4}>
            <Filters.Applications />
          </Grid>
          <Grid item xs={4}>
            <Filters.Channels withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Networks withFavoriteActions={true} />
          </Grid>
          {isAllowExclusiveForAffiliates ? (
            <Grid item xs={4}>
              <Filters.ExclusiveForAffiliates withFavoriteActions={true} />
            </Grid>
          ) : null}
          <Grid item xs={4}>
            <Filters.OS withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Genres withFavoriteActions={true} />
          </Grid>
        </Grid>
      </Section>
      <Section title={'Creative'}>
        <Grid container={true} spacing={2}>
          <Grid item xs={4}>
            <Filters.CreativeTypes withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Orientations withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Languages withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Lengths withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Sizes withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Resolutions withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.Ratios withFavoriteActions={true} />
          </Grid>
          {isAllowProductionType ? (
            <Grid item xs={4}>
              <Filters.ProductionTypes withFavoriteActions={true} />
            </Grid>
          ) : null}
          <Grid item xs={4}>
            <Filters.Enhancers withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.MediaTypes withFavoriteActions={true} />
          </Grid>
          {isAllowTested ? (
            <Grid item xs={4}>
              <Filters.Tested withFavoriteActions={true} />
            </Grid>
          ) : null}
        </Grid>
      </Section>

      <Section title={'Metadata'}>
        <Grid container={true} spacing={2}>
          <Grid item xs={4}>
            <Filters.IncludedTags withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.ExcludedTags withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.AITaggingStatusTags withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.AITags withFavoriteActions={true} />
          </Grid>
          {isAllowStatuses && (
            <Grid item xs={4}>
              <Filters.Statuses withFavoriteActions={true} />
            </Grid>
          )}
          {isAllowConceptFamilies && (
            <Grid item xs={4}>
              <Filters.ConceptFamilies />
            </Grid>
          )}
          <Grid item xs={4}>
            <Filters.Comments withFavoriteActions={true} />
          </Grid>
          {isAllowPerformance && (
            <Grid item xs={4}>
              <Filters.UsedInAds withFavoriteActions={true} />
            </Grid>
          )}
          {isAllowPerformance && (
            <Grid item xs={4}>
              <Filters.UsedInAffiliates
                dropdownWidth={'440px'}
                withFavoriteActions={true}
              />
            </Grid>
          )}
          <Grid item xs={4}>
            <Filters.IsNew withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.AIGenerated withFavoriteActions={true} />
          </Grid>
          {isAllowPromoCodes && (
            <Grid item xs={4}>
              <Filters.PromoCodes withFavoriteActions={true} />
            </Grid>
          )}
          <Grid item xs={4}>
            <Filters.IncludeYTLink withFavoriteActions={true} />
          </Grid>
        </Grid>
      </Section>
      <Section title={'Entity'}>
        <Grid container={true} spacing={2}>
          {isAllowBusinessPartner && (
            <Grid item xs={4}>
              <Filters.BusinessPartners />
            </Grid>
          )}
          {isAllowDesigner && (
            <Grid item xs={4}>
              <Filters.Designers withFavoriteActions={true} />
            </Grid>
          )}
          {isAllowOutsourceStudio && (
            <Grid item xs={4}>
              <Filters.OutsourceStudios withFavoriteActions={true} />
            </Grid>
          )}
          {isAllowRequestedBy && (
            <Grid item xs={4}>
              <Filters.RequestedBy />
            </Grid>
          )}
          <Grid item xs={4}>
            <Filters.CreatedBy withFavoriteActions={true} />
          </Grid>
          <Grid item xs={4}>
            <Filters.FilterBy />
          </Grid>
          {isAllowSharedWith && (
            <Grid item xs={4}>
              <Filters.SharedWith withFavoriteActions={true} />
            </Grid>
          )}
        </Grid>
      </Section>
    </AllFiltersProvider>
  );
};

export default AllFilters;
